<template lang="pug">
  .container.field.column
    label.title Address Lines
    .address-line(v-for="(address, index) in addressLines" :key="index")
      .address-line__header
        lei-popover(:text="getTextByPath(address.jsonPath)" placement="right")
          label.label {{getLabelByPath(address.jsonPath)}}
        .address-line__header-filler
        .remove-group(@click="() => $emit('remove', index)")
          i.remove-text-btn.text-btn Remove
          font-awesome-icon.icon.remove-icon(icon="times-circle")
      .address-line-input
        .compare-block
          .old-block
            el-input.lei-input(:value="getValue(index)" disabled)
          .new-block
            el-input.lei-input(:value="address.value" @input="value => $emit('change', {value, index})")
    a.text-btn(v-if="newLineCanBeAdded" @click="() => $emit('add')") Add address line
</template>
<script>
import LeiPopover from '../lei-components/LeiPopover'
import { getLabelByPath, getTextByPath, } from '@/utils/challenge'

export default {
  components: { LeiPopover, },
  props: {
    addressLines: {
      type: Array,
      required: true,
    },
    oldAddressLines: {
      type: Array,
      required: true,
    },
  },
  computed: {
    newLineCanBeAdded () {
      return this.addressLines.length < 2
        || (this.addressLines.length < 4 && !!this.addressLines.slice(-1)[0].value)
    },
  },
  methods: {
    getTextByPath,
    getLabelByPath,
    getValue (index) {
      return index >= this.oldAddressLines.length ? '' : this.oldAddressLines[index]
    },
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  .challenge-modal

    .address-line-input
      display flex
      align-items center
      .compare-block
        display flex
        flex-direction column
        flex 1
        .old-block, .new-block
          flex 1
          display flex
          flex-direction column
        .old-block
          margin-bottom 5px

    .address-line
      display flex
      flex-direction column
      margin-bottom 15px

      &__header
        display flex
        align-items center
        margin 5px 0 10px

      &__header-filler
        flex 1

      .label
        font-size 0.9rem
        color $default-color
        margin 0
        display inline-flex
        align-items center

    .text-btn
      font-size 90%
      color $default-color-middle
      text-decoration underline

      &:hover
        color $primary-color

    .remove-group
      display flex
      align-items center
      cursor pointer
      &:hover
        .remove-icon,.remove-text-btn
          color $danger-color

    .remove-icon
      margin-left 5px
      font-size 125%

    .remove-text-btn
      font-style normal
      display none

    .description
      text-align justify
      color $default-color
      line-height 1.25

  @media (min-width: $mobile)
    .challenge-modal
      .remove-text-btn
        display inline
      .remove-icon
        display none
      .address-line-input
        .compare-block
          flex-direction row
          .old-block
            margin 0 5px 0 0

  @media (min-width: $laptop)
    .challenge-modal
      .address-line-input
        .compare-block
          .old-block
            margin-right 20px
          .new-block
            margin-left 20px
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeAddressLines.vue